// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"ImageUploadView_rootContainer__23EtE"};